import * as React from "react";
import { useHistory } from "react-router-dom";

// Components
import Button from "../Button/Button";
import IconCheckmark from "../Icons/IconCheckmark";

// Styles
import "./GuidelineCTA.scss";

const GuidelineCTA: React.FC = () => {
  const history = useHistory();

  return (
    <div className="guideline-cta relative bg-dw-grey-01 p-3 mt-4 overflow-hidden">
      <p className="text-dw-blue text-l font-serif font-semibold">
        Already started with your crisis plan?
      </p>
      <p className="text-dw-blue font-bold my-3">
        Upload your file here and continue.
      </p>
      <Button
        type="button"
        buttonType="secondary"
        onClick={() => {
          history.push("/continue");
        }}
      >
        Continue crisis plan
      </Button>
      <IconCheckmark className="absolute" />
    </div>
  );
};

export default GuidelineCTA;
